// app/packages/platform-contract/src/signature/document-image.schema.ts
//
// DocumentImage aggregate — one row per signature slot (Stages 3 + 5 of the
// seven-stage pipeline). Mirrors design.md §6 (doc-signature-stubs).
import { z } from 'zod';

export const DocumentImageSchema = z.object({
  documentImageId: z.string().guid(),
  sourceId: z.string().guid(),
  sourceTable: z.string().min(1).max(128),
  documentType: z.string().min(1).max(100),
  documentImageType: z.string().min(1).max(128),
  /** null = unsigned slot (manual-sign branch); otherwise base64 PNG bytes. */
  imageBase64: z.string().nullable(),
  orderId: z.number().int().min(1).max(255),
  /** null until Stage 5 back-link runs (spDocumentImage_Update). */
  documentId: z.string().guid().nullable(),
  employeeId: z.string().guid().nullable(),
  isRequired: z.boolean(),
  /** Computed = imageBase64 !== null (mirrors the DB computed column). */
  isSigned: z.boolean(),
});

export type DocumentImage = z.infer<typeof DocumentImageSchema>;
